import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			La Kontraŭpluva mantelo ne kontentas pri sia vivo. 
			Dum la vetero hela, suna, kiam oni devas promenadi plezure, lin oni tenas en la ŝranko. 
			Sed kiam oni lin ellasas el la domo – ĉiam pluvas.
		</p>
		
		<p class="mb-3">
			Ĉu tio estas hazarda koincido – aŭ intenca insido?
		</p>
		`
	)
}

const itemName = {
	esp: 'Demando de la vivo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;